import { Box, Typography } from "@mui/joy";
import { motion } from "framer-motion";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";

/** Короткое «почему подходит» от умного подбора (поле ai_reason из ленты).
 *  Рендерится только если причина непустая. props: reason (string|undefined) */
export default function AiReasonChip({ reason }) {
  if (!reason || !String(reason).trim()) return null;
  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
      sx={{
        mt: 1,
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.5,
        borderRadius: "999px",
        backgroundColor: "rgba(124,58,237,0.85)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        maxWidth: "100%",
      }}
    >
      <AutoAwesomeRoundedIcon sx={{ fontSize: 14, color: "#fff", flexShrink: 0 }} />
      <Typography
        sx={{
          color: "#fff",
          fontWeight: 600,
          fontSize: 12,
          lineHeight: 1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {reason}
      </Typography>
    </Box>
  );
}